
    import * as React from 'react';

    const ChevronLeft12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="ChevronLeft_12_svg__Icons/Chevron/Left/12" stroke="none" strokeWidth={1} fillRule="evenodd"><g id="ChevronLeft_12_svg__Icons/Chevron/Down/12" transform="translate(6.000000, 6.000000) rotate(90.000000) translate(-6.000000, -6.000000) translate(0.000000, 2.500000)" fillRule="nonzero"><polygon id="ChevronLeft_12_svg__Line-4" points="1.26552967 0.735200089 0.734470328 1.26479991 5.95634722 6.50106775 11.2633249 1.26699255 10.7366751 0.733007448 5.96073257 5.44334247" /></g></g></svg>
        </div>
      );
    };

    ChevronLeft12.displayName = 'ChevronLeft12';

    export default ChevronLeft12;
  